import React, { Fragment } from "react"
//import { Link } from "gatsby"

import Layout from "../components/layout"
import SEO from "../components/seo"

import PageTitle from "../components/page-title/page-title"

import ContactForm from "../components/contact-form/contact-form"
const pageHeading = "Contact"
const pageSubHeading =
  "To get in touch, please fill out the form fields below and press the submit button."
const ContactPage = () => (
  <Layout>
    <SEO title="Contact" />

    <article className="contact">
      <div className="contact-head">
        <div className="container">
          <PageTitle pageHeading={pageHeading} />
        </div>
      </div>

      <div className="contact-intro">
        <div className="container">
          <h2 className="fade-in">{pageSubHeading}</h2>
        </div>
      </div>

      <div className="contact-body">
        <div className="container">
          <ContactForm />
        </div>
      </div>
    </article>
  </Layout>
)

export default ContactPage
